const STORAGE_KEY = "fschool-republic-company-favorites";

function readIds() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.map(Number).filter((id) => !Number.isNaN(id)) : [];
  } catch {
    return [];
  }
}

function writeIds(ids) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
}

export function loadFavoriteCompanyIds() {
  return readIds();
}

export function isFavoriteCompany(companyId) {
  return readIds().includes(Number(companyId));
}

export function addFavoriteCompany(companyId) {
  const id = Number(companyId);
  if (Number.isNaN(id)) {
    return readIds();
  }
  const ids = readIds();
  if (ids.includes(id)) {
    return ids;
  }
  const next = [...ids, id];
  writeIds(next);
  return next;
}

export function removeFavoriteCompany(companyId) {
  const id = Number(companyId);
  const next = readIds().filter((item) => item !== id);
  writeIds(next);
  return next;
}

export function toggleFavoriteCompany(companyId) {
  const id = Number(companyId);
  if (Number.isNaN(id)) {
    return readIds();
  }
  const ids = readIds();
  if (ids.includes(id)) {
    return removeFavoriteCompany(id);
  }
  return addFavoriteCompany(id);
}
